<template>
  <div class="app-container">
    <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
    <BjPage ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :radio="radio"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      :selection="selection"
      :row-style="rowStyleFun"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <el-col v-if="!$store.getters.cusId" :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Customer')" prop="csgCustomer">
              <BjSelectLov v-model="queryParams.csgCustomer" :option-list="customerNameList" :placeholder="$t('workOrderList.Customer')"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('orderNewPatch.order')" prop="orderNo">
              <BjInput v-model="queryParams.orderNo" :placeholder="$t('orderNewPatch.order')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <!-- 异常订单 操作 -->
          <!-- <el-col>
            <el-button type="primary" class="main-btn" :disabled="btnOrderStatus!=0" @click="$refs.failReason.show()">{{ $t('InternalOrder.AddException') }}</el-button>
            <el-button type="primary" :disabled="btnOrderStatus!=3" @click="_orderNormal">{{ $t('InternalOrder.ReleaseException') }}</el-button>
          </el-col> -->
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo, false, businessType)">{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'innerOrderNo'">
                  <span class="link" @click="goInnerView(scope)">{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <template v-else-if="col.prop === 'ErrorMsg'">
                  <span class="el-icon-info right-icon" @click="seeReason(scope.row.innerOrderNo)"></span>
                </template>
                <template v-else-if="col.prop === 'tagsList'">
                  <BjTagList :tag-code-array="scope.row[col.prop]" size="mini" circle />
                </template>
                <template v-else-if="col.prop === 'orderStatusStr'">
                  <el-tag :type="scope.row[col.prop] === 'Proccessing' ? 'success' : 'info'">{{ scope.row[col.prop] }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'exceptionReason'">
                  {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'actionType'">
                  {{ $t(ORDER_ACTION_TYPE_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'orderTime'">
                  <span>{{ scope.row[col.prop] | timeOptimization }}</span>
                </template>
                <template v-else-if="col.prop === 'creationDate'">
                  <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
                </template>
                <template v-else-if="col.prop === 'preemptionStatus'">
                  {{ $t(ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'sourceStatus'">
                  {{ $t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'suspendStatus'">
                  {{ $t(ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="delete-btn" @click="onPreemption(props.row)">{{ $t('RefundOnlyToBeReviewed.form.Preemption') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi, settingApi, userApi } from '@/api';
import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
  LANG_ZH_EN_PS_LIST,
  ORDER_ACTION_TYPE_LIST,
  ORDER_INTERNAL_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
} from '@/utils/constants';
import moment from 'moment';

export default {
  name: 'BusinessAbnormalOrderEXCEPTION',
  components: {
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      radio: false,
      colSpan: 4,
      ORDER_ABNORMAL_FIVE_ROUTE_LIST,
      LANG_ZH_EN_PS_LIST,
      ORDER_ACTION_TYPE_LIST,
      ORDER_INTERNAL_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      queryApi: orderApi.getOrderOperationPage,
      // 查询参数
      queryParams: {
        cusId: null,
        csgCustomer: null,
        orderNo: null,
        operationType: Number(1),
        tags: '',
      },
      labelList: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false,},
        { label: this.$t('workOrderList.Customer'), prop: 'csgCustomer', isCheck: true, disabled: false, },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false },
        { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false },
        { label: this.$t('InternalOrder.form.err'), prop: 'ErrorMsg', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.Label'), prop: 'tagsList', isCheck: false, disabled: false, },
        { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.AbnormalCause'), prop: 'exceptionReason', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false },
        { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false },
        { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('InternalOrder.form.Pre'), prop: 'preemptionStatus', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.Sourcing'), prop: 'sourceStatus', isCheck: false, disabled: false },
        { label: this.$t('InternalOrder.form.Pending'), prop: 'suspendStatus', isCheck: false, disabled: false },
      ],
      // 客服下拉列表
      customerNameList:[],
    };
  },
  created(){
    // 获取客服下拉框数据
    this.getCustomerList()
  },
  methods: {
    // 标红超时订单
    rowStyleFun({ row, rowIndex }) {
      const styleJson = {};
      const now = moment().day();
      const start = new Date();
      let deliveryTimeEnd;
      if([1].includes(now)){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
        deliveryTimeEnd = moment(start).format('YYYY-MM-DD HH:mm:ss')
      }else if([2,3,4,5].includes(now)){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        deliveryTimeEnd = moment(start).format('YYYY-MM-DD HH:mm:ss')
      }else if([6].includes(now)){
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        deliveryTimeEnd = moment(start).format('YYYY-MM-DD 00:00:00')
      }else{
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
        deliveryTimeEnd = moment(start).format('YYYY-MM-DD 00:00:00')
      }
      if(moment(this.timeFilters2(row.creationDate)).isBefore(moment(deliveryTimeEnd))){
        styleJson.color = 'red';
      }
      return this.$store.getters.cusId ? {} : styleJson;
    },
    timeFilters2(date) {
      if (date) {
        // 获取澳洲当前时间与本地时间的时差
        const timeHour = sessionStorage.getItem('timeHour') || '2';
        var time = Date.parse(new Date(date));
        var newTime = moment(time + timeHour * 3600000).format('YYYY-MM-DD HH:mm:ss');
        return newTime;
      }
    },
    // 获取客服下拉数据
    getCustomerList(){
      userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
        this.customerNameList = res.content.map(item => {
          return { label: item.realName, value: item.realName };
        });
      })
    },
    // 预占按钮
    onPreemption(r) {
      orderApi.preemptionOrder({innerOrderNo: r.innerOrderNo}).then(e => {
        if (e.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
          }
      });
    },
    // 跳转内部详情
    goInnerView(scope) {
      this.$router.push({
        name: 'BusinessOrderInternalViewCSG',
        // operationType : 1.推送异常，0.预占超时
        query: { id: '', code: scope.row.innerOrderNo, operationType: 1,},
      });
    },
    // 点击查看失败原因
    seeReason(e) {
      settingApi.getTaskInstanceMessage({innerOrderNo: e}).then(res => {
        const str = res.exceptionMessage;
        const str1 = str.substring((str.indexOf(':') + 1), str.indexOf('\n\t'));
        this.$alert(str1, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        type: 'warning',
        callback: action => {},
      });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
